export const SMS_CHAT_GET_CHATS_START = 'SMS_CHAT_GET_CHATS_START';
export const SMS_CHAT_GET_CHATS_SUCCESS = 'SMS_CHAT_GET_CHATS_SUCCESS';
export const SMS_CHAT_GET_CHATS_FAIL = 'SMS_CHAT_GET_CHATS_FAIL';

export const SMS_CHAT_SET_CHATS = 'SMS_CHAT_SET_CHATS';

export const SMS_CHAT_SET_LOCAL_CHATS = 'SMS_CHAT_SET_LOCAL_CHATS';

export const SMS_CHAT_LINK_TO_INSURED_START = 'SMS_CHAT_LINK_TO_INSURED_START';
export const SMS_CHAT_LINK_TO_INSURED_SUCCESS = 'SMS_CHAT_LINK_TO_INSURED_SUCCESS';
export const SMS_CHAT_LINK_TO_INSURED_FAIL = 'SMS_CHAT_LINK_TO_INSURED_FAIL';

export const SMS_CHAT_CHANGE_CHAT_NAME_START = 'SMS_CHAT_CHANGE_CHAT_NAME_START';
export const SMS_CHAT_CHANGE_CHAT_NAME_SUCCESS = 'SMS_CHAT_CHANGE_CHAT_NAME_SUCCESS';
export const SMS_CHAT_CHANGE_CHAT_NAME_FAIL = 'SMS_CHAT_CHANGE_CHAT_NAME_FAIL';

export const SMS_CHAT_CHECK_EXISTED_CHAT_START = 'SMS_CHAT_CHECK_EXISTED_CHAT_START';
export const SMS_CHAT_CHECK_EXISTED_CHAT_SUCCESS = 'SMS_CHAT_CHECK_EXISTED_CHAT_SUCCESS';
export const SMS_CHAT_CHECK_EXISTED_CHAT_FAIL = 'SMS_CHAT_CHECK_EXISTED_CHAT_FAIL';

export const SMS_CHAT_DELETE_CHAT_START = 'SMS_CHAT_DELETE_CHAT_START';
export const SMS_CHAT_DELETE_CHAT_SUCCESS = 'SMS_CHAT_DELETE_CHAT_SUCCESS';
export const SMS_CHAT_DELETE_CHAT_FAIL = 'SMS_CHAT_DELETE_CHAT_FAIL';

export const SMS_CHAT_UNLINK_CONVERSATION_FROM_INSUREDS_NOTES_START = 'SMS_CHAT_UNLINK_CONVERSATION_FROM_INSUREDS_NOTES_START';
export const SMS_CHAT_UNLINK_CONVERSATION_FROM_INSUREDS_NOTES_SUCCESS = 'SMS_CHAT_UNLINK_CONVERSATION_FROM_INSUREDS_NOTES_SUCCESS';
export const SMS_CHAT_UNLINK_CONVERSATION_FROM_INSUREDS_NOTES_FAIL = 'SMS_CHAT_UNLINK_CONVERSATION_FROM_INSUREDS_NOTES_FAIL';

export const SMS_CHAT_MARK_AS_UNREAD_START = 'SMS_CHAT_MARK_AS_UNREAD_START';
export const SMS_CHAT_MARK_AS_UNREAD_SUCCESS = 'SMS_CHAT_MARK_AS_UNREAD_SUCCESS';
export const SMS_CHAT_MARK_AS_UNREAD_FAIL = 'SMS_CHAT_MARK_AS_UNREAD_FAIL';

export const SMS_CHAT_MUTE_NOTIFICATION_START = 'SMS_CHAT_MUTE_NOTIFICATION_START';
export const SMS_CHAT_MUTE_NOTIFICATION_SUCCESS = 'SMS_CHAT_MUTE_NOTIFICATION_SUCCESS';
export const SMS_CHAT_MUTE_NOTIFICATION_FAIL = 'SMS_CHAT_MUTE_NOTIFICATION_FAIL';

export const SMS_CHAT_UNMUTE_NOTIFICATION_START = 'SMS_CHAT_UNMUTE_NOTIFICATION_START';
export const SMS_CHAT_UNMUTE_NOTIFICATION_SUCCESS = 'SMS_CHAT_UNMUTE_NOTIFICATION_SUCCESS';
export const SMS_CHAT_UNMUTE_NOTIFICATION_FAIL = 'SMS_CHAT_UNMUTE_NOTIFICATION_FAIL';

export const SMS_CHAT_UPDATE_CHAT_NAMES_START = 'SMS_CHAT_UPDATE_CHAT_NAMES_START';
export const SMS_CHAT_UPDATE_CHAT_NAMES_SUCCESS = 'SMS_CHAT_UPDATE_CHAT_NAMES_SUCCESS';
export const SMS_CHAT_UPDATE_CHAT_NAMES_FAIL = 'SMS_CHAT_UPDATE_CHAT_NAMES_FAIL';

export const SMS_CHAT_MARK_AS_STARRED_START = 'SMS_CHAT_MARK_AS_STARRED_START';
export const SMS_CHAT_MARK_AS_STARRED_SUCCESS = 'SMS_CHAT_MARK_AS_STARRED_SUCCESS';
export const SMS_CHAT_MARK_AS_STARRED_FAIL = 'SMS_CHAT_MARK_AS_STARRED_FAIL';

export const SMS_CHAT_MARK_AS_READ_START = 'SMS_CHAT_MARK_AS_READ_START';
export const SMS_CHAT_MARK_AS_READ_SUCCESS = 'SMS_CHAT_MARK_AS_READ_SUCCESS';
export const SMS_CHAT_MARK_AS_READ_FAIL = 'SMS_CHAT_MARK_AS_READ_FAIL';
